const integerRatio = (value, paper, scale) => {
  if (value == null || paper == null || Number(paper) <= 0) return "";
  const atoms = Math.round(Number(value) * scale);
  const denomination = Math.round(Number(paper) * scale);
  return denomination > 0 && atoms % denomination === 0 ? atoms / denomination : "";
};

export const getPhysicalPaperForm = (voucher = {}) => {
  const scale = voucher.tipo === "MONTO" ? 100 : 1;
  const paper = voucher.limitePedido ?? voucher.cantidad ?? "";
  return {
    cantidadPapeles: integerRatio(voucher.cantidad, paper, scale),
    valorPapel: paper,
    limitarPorDia: voucher.limiteDiario != null,
    papelesPorDia: integerRatio(voucher.limiteDiario, paper, scale),
  };
};

export const calculatePhysicalPaperForm = ({ tipo, cantidadPapeles, valorPapel, limitarPorDia, papelesPorDia }) => {
  const count = Number(cantidadPapeles);
  const paper = Number(valorPapel);
  const daily = Number(papelesPorDia);
  const scale = tipo === "MONTO" ? 100 : 1;
  const atoms = Math.round(paper * scale);
  const error = (field, message, fields = {}) => ({ ...fields, field, message });
  if (!Number.isSafeInteger(count) || count <= 0) return error("cantidadPapeles", "Ingresá una cantidad entera de papeles mayor que cero.");
  if (!Number.isFinite(paper) || paper <= 0 || !Number.isSafeInteger(atoms)
    || (tipo === "MONTO" ? Number(paper.toFixed(2)) !== paper : !Number.isInteger(paper))) {
    return error("valorPapel", tipo === "MONTO" ? "Ingresá el valor de cada papel, con hasta dos decimales." : "Ingresá las unidades enteras que cubre cada papel.");
  }
  if (!Number.isSafeInteger(atoms * count)) return error("cantidadPapeles", "El presupuesto de la tanda es demasiado grande.");
  const fields = { cantidad: atoms * count / scale, limitePedido: atoms / scale, limiteDiario: null };
  if (limitarPorDia) {
    if (!Number.isSafeInteger(daily) || daily <= 0 || !Number.isSafeInteger(atoms * daily)) {
      return error("papelesPorDia", "Ingresá una cantidad entera de papeles por día mayor que cero.", fields);
    }
    fields.limiteDiario = atoms * daily / scale;
  }
  return fields;
};
